import React from 'react';
import Button from '@mui/material/Button';
import { Auth, Hub } from 'aws-amplify'; 


export const SignOutButton = ({ user, handleSignOut }) => (
  user && (
    <div className="signout-container">
        <b>{user.attributes.email}</b>
        <Button className="signout-button" onClick={handleSignOut}>
          Sign out
        </Button>
    </div>
  )
);

export const handleSignOut = async (setUser) => {
    try {
      await Auth.signOut();
      setUser(null);
      window.location.reload();
    } catch (error) {
      console.log('Error signing out: ', error);
    }
  };

export const checkUser = async (setUser, onAuthStateChange) => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      setUser(currentUser);
      onAuthStateChange('signedIn'); 
    } catch (error) {
      setUser(null);
      onAuthStateChange('signedOut');
    }
};

export const removeHubListener = (onAuthStateChange) => Hub.listen('auth', ({ payload: { event, data } }) => {
    if (event === 'signIn') {
      onAuthStateChange('signedIn');
    } else if (event === 'signOut') {
      onAuthStateChange('signedOut');
    }
});

// export default SignOutButton;